// eslint-disable-next-line import/no-anonymous-default-export
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

export const notifications = {
  success,
  error,
};

function success(message) {
  toast.success(message, {
    position: "bottom-right",
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

function error(message) {
  toast.error(message, {
    position: "bottom-right",
    autoClose: 2500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}
